/**
 * Get trigger resolution
 * @param {String} input
 * @returns {Map<"rest" | "resolution", String>}
 */
const getTriggerResolution = (input = "") => {
  if (input.includes("▶")) {
    const index = input.indexOf("▶");
    const resolution = input.slice(0, index);
    const rest = input.slice(index + 1);

    return new Map([
      ["resolution", resolution],
      ["rest", rest],
    ]);
  } else {
    return new Map([
      ["resolution", "all"],
      ["rest", input],
    ]);
  }
};

export default getTriggerResolution;
